export default "__VITE_ASSET__qlva8xup__"